// extracted by mini-css-extract-plugin
export const mainSection = "newsLetter-module--mainSection--3aeMM";
export const contentWrap = "newsLetter-module--contentWrap--jVVFB";
export const content = "newsLetter-module--content--uWaZ7";
export const wrapper = "newsLetter-module--wrapper--2CsLF";
export const form = "newsLetter-module--form--2Mmc6";
export const features = "newsLetter-module--features--1PPJm";
export const subscribe = "newsLetter-module--subscribe--2ZP4I";
export const componentWrapper = "newsLetter-module--componentWrapper--27ZvK";